import React, { useEffect, useState } from 'react';
import {
	SdfBusyIndicator,
	SdfFocusPane,
} from '@synerg/react-components';
import './apiPicker.scss';
import {
	clearDropdownSelections,
	intentDataList
} from "./apiDiscoveryWizard";
import ApiSearchPage from "./apiSearchPage/apiSearchPage";
import {
	useApplicationState,
	upsertToasts,
	updateIntentDropdownSelection
} from "../../utilities/applicationState";

export default function Wizard({
	open, openWizardFn, projectIdEncrypted, filteredApis, consumerApplicationID,
	subscribedEvents, scopeLastModified, productCode
}) {
	const [isBusy, setIsBusy] = useState(false);

	// this component handles showing/hiding guide or search page

	const [applicationState, dispatch] = useApplicationState();
	const { isApiContext } = applicationState.apiDiscovery;

	const setToast = (toast) => {
		if (typeof toast === "object") dispatch(upsertToasts(toast));
	}

	// set dropdowns search defaults on slide-in opening: list & selections
	useEffect(() => {
		if (open) {
			isApiContext ?
				dispatch(updateIntentDropdownSelection(intentDataList[0])) :
				dispatch(updateIntentDropdownSelection(intentDataList[1]));
		}
	}, [open]);


	const closeModal = () => {
		openWizardFn(false);

		clearDropdownSelections(dispatch);
	};

	const handleError = (message) => {
		setToast({
			status: "error",
			message: message,
			closable: 'true',
			toast: true,
			autoClose: true,
			autoCloseAfter: 30000
		});
	};

	return (<>
		<SdfFocusPane
			visible={open}
			paneType="anchored"
			size="full"
			hideAcceptButton={true}
			hideDismissButton={false}
			heading={'Discover APIs to add to your project'}
			onSdfDismiss={() => {
				closeModal();
			}}
			closeable={true}
			hideFooter={false}
			dismissLabel="Close"
		>
			{isBusy && <SdfBusyIndicator
				style={{ color: "#1a8099" }}
				size="lg"
				overlay={true}
				fullScreen={false}
			/>}
			:
			<ApiSearchPage
				open={open}
				setToast={setToast}
				handleError={handleError}
				filteredApis={filteredApis}
				projectIdEncrypted={projectIdEncrypted}
				consumerApplicationID={consumerApplicationID}
				closeModal={closeModal}
				subscribedEvents={subscribedEvents}
				productCode={productCode}
				scopeLastModified={scopeLastModified}
				setIsBusy={setIsBusy}
			/>
		</SdfFocusPane>
	</>
	)
}
